<template>
    <div class="modal is-active" v-on:keyup.enter="saveChange"  v-on:keyup.esc="closeBtn" >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title "  v-if="mode === 1" > Add New </p>
                <p class="modal-card-title "  v-if="mode === 2" > Edit </p>

                <button class="delete" aria-label="close" @click="closeBtn"></button>
            </header>
            <section class="modal-card-body">
                <!-- Content ... -->
                <b-field label="Title">
                    <b-input type="text" v-model="titleDxCode"/>
                </b-field>

                <b-field label="Code">
                    <b-input type="text" v-model="codeDxCode" />
                </b-field>


                <b-field label="Status">
                    <b-switch
                            type="is-success"
                            v-model="enableCode" >
                        {{ enableCode }}
                    </b-switch>
                </b-field>






            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  icon-left="cancel" @click="closeBtn">Cancel</b-button>
                <b-button type="is-success"  icon-left="cloud-upload" @click="saveData">Save</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios ,genUUID }  from '@/utils.js'
    import { mapState } from "vuex";

    export default {
        name: "EditAddDxCode",
        props:{
            idparent : String,
            dataToEdit : Object,
            mode : Number , // 1 === insert , 2 === update
            level : Number  // 1,2,3,4,5
        },
        mounted() {
            // console.log('mount EditAddDxCode')
            if(this.mode === 1){
                this.titleDxCode = ""
                this.codeDxCode = ""
                this.enableCode = true
            }else{
                this.titleDxCode = this.dataToEdit.name
                this.codeDxCode = this.dataToEdit.code
                this.enableCode = this.dataToEdit.status
            }
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            closeBtn(){
                this.$emit('closeEditAddDxCode')
            },
            saveReal(){
                const  vm = this
                const  datTo =     {    "id" : genUUID(12),
                                        "idparent": this.idparent,
                                        "name": this.titleDxCode,
                                        "code": this.codeDxCode ,
                                        "status": this.enableCode
                                    }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/insertnewdxcode`,datTo,getConfigAxios())
                .then(res=>{
                    vm.$buefy.toast.open({
                        duration: 2000,
                        message: `${res.data.msg}`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })

                    vm.$emit('closeEditAddDxCodeWithDataChange',{"idparent": vm.idparent ,"level":vm.level,"mode": vm.mode})
                })
            },
            updateReal(){
                const  vm = this
                const  datTo =     {
                    "id" : this.dataToEdit.id,
                    "idparent": this.idparent,
                    "name": this.titleDxCode,
                    "code": this.codeDxCode ,
                    "status": this.enableCode
                }

         
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatedxcode`,datTo,getConfigAxios())
                    .then(res=>{
                        vm.$buefy.toast.open({
                            duration: 2000,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })

                        vm.$emit('closeEditAddDxCodeWithDataChange',{"idparent": vm.idparent ,"level":vm.level,"mode": vm.mode})
                    })



            },
            saveData(){

                if(this.mode === 1){
                    this.saveReal()
                }else if(this.mode === 2){
                    this.updateReal()
                }

            }
        },
        data(){
            return{
                titleDxCode : "" ,
                codeDxCode : "",
                enableCode : true
            }
        }
    }
</script>

<style scoped>

</style>